import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.965 12a8.965 8.965 0 1 0-17.93 0A8.965 8.965 0 0 0 12 20.965 8.965 8.965 0 0 0 20.965 12m-5.196-3.731A1.034 1.034 0 1 1 17.23 9.73l-6 6a1.034 1.034 0 0 1-1.462 0l-3-3A1.034 1.034 0 1 1 8.23 11.27l2.269 2.268zM23.035 12c0 6.095-4.94 11.035-11.035 11.035S.965 18.095.965 12 5.905.965 12 .965 23.035 5.905 23.035 12"
}));
export default SvgCheckCircle;
//# sourceMappingURL=CheckCircle.js.map